/** @type {import('tailwindcss').Config} */
module.exports = {
  prefix: '',
  content: ['./src/**/*.{html,ts}', './libs/**/*.{html,ts}'],
  darkMode: 'class', // or 'media' or 'class'
  theme: {
    screens: {
      sm: '600px',
      md: '960px',
      lg: '1280px',
      xl: '1920px',
    },
    extend: {
      touchAction: {
        none: 'none',
        manipulation: 'manipulation',
      },
      backgroundImage: {
        'gradient-radial': 'radial-gradient(var(--tw-gradient-stops))',
      },
      boxShadow: {
        'l-md':
          '-4px 0 6px -1px rgba(0, 0, 0, 0.1), -2px 0 4px -1px rgba(0, 0, 0, 0.06)',
      },
      keyframes: {
        pop: {
          '0%, 100%': { transform: 'scale(1)' },
          '30%': { transform: 'scale(1.05)' },
        },
        shrink: {
          '0%, 100%': { transform: 'scale(1)' },
          '20%': { transform: 'scale(1.1)' },
          '60%': { transform: 'scale(0.6)' },
        },
        pulsation: {
          '0%, 100%': { transform: 'scale(1.05)' },
          '50%': { transform: 'scale(0.95)' },
        },
        load: {
          '0%': { width: '0%' },
          '100%': { width: '100%' },
        },
      },
      animation: {
        pop: 'pop 0.6s ease-in-out',
        shrink: 'shrink 0.6s ease-in-out',
        pulsation: 'pulsation 2s ease-in-out infinite',

        load: 'load 3s ease-out forwards',
      },
    },
  },
  variants: {
    extend: {},
  },
  plugins: [
    require('daisyui'),
    require('tailwindcss-themer')({
      defaultTheme: {
        extend: {
          fontFamily: {
            sans: ['Roboto Flex', 'Roboto', 'Helvetiva', 'Arial', 'sans-serif'],
          },
          fontSize: {
            small: '0.8rem',
            normal: '1rem',
            large: '1.3rem',
            xlarge: '1.6rem',
          },
          colors: {
            'bo-white': '#FFFFFF',
            'bo-grey': '#8B8B8B',
            'bo-primary': '#EA1700',
            'bo-secondary': '#888B8D',
            'bo-shady-white': '#F4F4F4',
            'bo-shady-dark': '#63666A',
            'bo-black': '#212121',
            'bo-red': '#CE4248',
            'bo-orange': '#F37602',
            'bo-blue': '#1B7DB5',
            'bo-accent-blue': '#216084',
            'bo-green': '#41754C',
            'bo-yellow': '#FFC700',
          },
          textUnderlineOffset: {
            6: '6px',
          },
          textDecorationThickness: {
            3: '3px',
          },
        },
      },
      themes: [
        {
          name: 'ethicon',
          extend: {
            colors: {
              'bo-primary': '#EA1700',
              'bo-secondary': '#888B8D',
              'bo-shady-white': '#F4F4F4',
              'bo-shady-dark': '#63666A',
              'bo-black': '#212121',
            },
          },
        },
      ],
    }),
    // ...
  ],
  daisyui: {
    themes: ['light'],
    logs: false,
  },
};
